import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import htmlReactParser from 'html-react-parser';

import {
	openModal,
} from '../../store/actions/modal';

import {
	addSample,
	removeSample,
} from '../../store/actions/sampleCart';

import './C2-search-results.scss';

import C3Filter from '../C3-filter/C3-filter';

class C2SearchResults extends Component {
	constructor(props) {
		super(props);

		this.fetchResults = _.debounce(this.fetchResults.bind(this), 200);

		this.pageIndex = 0;
		this.query = props.data.endpointParams.query;
		this.language = null;

		this.state = {
			pageTotal: 0,
			resultsTotal: 0,
			results: [],
			filterData: {},
			waiting: false,
		};
	}

	componentDidMount() {
		this.fetchResults();
	}

	componentDidUpdate(prevProps) {
		const { selectedTopics, selectedCategories, filterLanguage } = this.props;

		if (!_.isEqual(prevProps.selectedTopics, selectedTopics)
		|| !_.isEqual(prevProps.selectedCategories, selectedCategories)
		|| !_.isEqual(prevProps.filterLanguage, filterLanguage)
		) {
			this.fetchResults();
		}
	}

	onLoginOpen = (event) => {
		event.preventDefault();
		const { dispatch } = this.props;
		dispatch(openModal('login', {}));
	}

	toggleSample = (event, id) => {
		event.preventDefault();
		const {
			dispatch,
			sampleCartProducts,
		} = this.props;

		if (sampleCartProducts.indexOf(id) > -1) {
			dispatch(removeSample(id));
		} else {
			dispatch(addSample(id));
		}
	}

	paginate = (evt) => {
		const { direction } = evt.currentTarget.dataset;
		const oldPageIndex = this.pageIndex;

		if (direction === 'back') {
			this.pageIndex -= 1;
		}

		if (direction === 'forward') {
			this.pageIndex += 1;
		}

		if (oldPageIndex !== this.pageIndex) {
			this.fetchResults();
		}
	}

	fetchResults() {
		const { filterData } = this.state;
		const {
			data,
			selectedTopics,
			selectedCategories,
			filterLanguage,
		} = this.props;
		const { endpoint, endpointParams } = data;
		let filterIds = [];

		this.setState({ waiting: true });

		if (!_.isEmpty(filterData)) {
			Array.from(filterData.availableFilters.sections).forEach((section) => {
				if (!_.isEmpty(selectedTopics[section.id])) {
					filterIds = filterIds.concat(selectedTopics[section.id]);
				}
				if (!_.isEmpty(selectedCategories[section.id])) {
					filterIds = filterIds.concat(selectedCategories[section.id]);
				}

				this.language = null;
				if (!_.isEmpty(filterLanguage[section.id])) {
					this.language = filterLanguage[section.id];
				}
			});
		}

		const postData = {
			...endpointParams,
			pageIndex: this.pageIndex,
			query: this.query || endpointParams.query,
			lang: this.language || endpointParams.lang,
			filterIds,
		};

		fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(postData),
		}).then((response) => { return response.json(); })
			.then((json) => {
				const {
					query,
					page,
					totalPages,
					totalResults,
					products,
					filters,
				} = json;

				this.pageIndex = page;
				this.query = query || '';

				if (products && totalPages && totalResults && filters) {
					this.setState({
						pageTotal: totalPages,
						resultsTotal: totalResults,
						results: products,
						filterData: filters,
						waiting: false,
					});
				}
			}).catch((error) => {
				console.error(error);
			});
	}

	renderPagination = () => {
		const { pageTotal } = this.state;
		const {
			data: {
				content: {
					ofString, // can't just use 'of' as it's a reserved word
				},
			},
		} = this.props;

		return (
			/* eslint-disable react/jsx-one-expression-per-line */
			<React.Fragment>
				<button type="button" disabled={this.pageIndex <= 0} className="C2-search-results__pagination__back" data-direction="back" onClick={this.paginate} />
				<p className="C2-search-results__pagination__label">
					{this.pageIndex + 1} {ofString} {pageTotal}
				</p>
				<button type="button" disabled={this.pageIndex >= (pageTotal - 1)} className="C2-search-results__pagination__forward" data-direction="forward" onClick={this.paginate} />
			</React.Fragment>
			/* eslint-enable react/jsx-one-expression-per-line */
		);
	}

	removeNonBreakingSpaces = (text) => {
		const clean = text.split(/\s|&nbsp;/i).join(' ');
		return clean;
	}

	renderResult = (result) => {
		const {
			userLoggedIn,
			viewport,
			sampleCartProducts,
			data: {
				endpointDownloadAll,
				content: {
					addSample: addSampleString,
					removeSample: removeSampleString,
					please,
					logIn,
					logInDesktopString,
					download,
				},
			},
		} = this.props;
		const {
			id,
			productName: name,
			productDescription: description,
			documents,
		} = result;

		const sampleButton = (
			<a
				href="#sample"
				className={(sampleCartProducts.indexOf(id) > -1) ? 'C2-search-results__remove' : 'C2-search-results__add'}
				onClick={(event) => { this.toggleSample(event, id); }}
			>
				{ (sampleCartProducts.indexOf(id) > -1) ? removeSampleString : addSampleString }
			</a>
		);

		const loginText = this.removeNonBreakingSpaces(logInDesktopString);

		const loginButton = (
			<span className="C2-search-results__login">
				{please}
				<a href="#login" onClick={this.onLoginOpen}>{logIn}</a>
				{['lg', 'xl', 'xxl'].includes(viewport) ? loginText : ''}
			</span>
		);

		return (
			<div className="C2-search-results__result" key={id}>
				<div className="C2-search-results__product">
					<div className="C2-search-results__product__name">{ htmlReactParser(name) }</div>
					<div className="C2-search-results__product__description">{ htmlReactParser(description) }</div>
				</div>
				<div className="C2-search-results__documents">
					{(documents.length > 0) ? <a href={`${endpointDownloadAll}?productId=${id}`} className="C2-search-results__download">{download}</a> : null}
					<ul className="C2-search-results__documents__list">
						{ documents.map((doc) => {
							return (
								<li key={doc.id} className="C2-search-results__documents__list__item">
									{(userLoggedIn || !doc.isGatedDocument) ? <a href={doc.documentLink} target="_blank" rel="noopener">{doc.documentName}</a> : doc.documentName }
								</li>
							);
						}) }
					</ul>
				</div>
				<div className="C2-search-results__sample">
					{ userLoggedIn ? sampleButton : loginButton }
				</div>
			</div>
		);
	}

	render() {
		const {
			viewport,
			data: {
				filterProps,
				content: {
					headerProductNameAndHero,
					headerDocuments,
					headerRequestASample,
					resultsString,
				},
			},
		} = this.props;

		const {
			results,
			resultsTotal,
			filterData,
			pageTotal,
			waiting,
		} = this.state;

		const resultsHeader = (
			<div className="C2-search-results__results-header">
				<div className="C2-search-results__results-header__product">{headerProductNameAndHero}</div>
				<div className="C2-search-results__results-header__documents">{headerDocuments}</div>
				<div className="C2-search-results__results-header__sample">{headerRequestASample}</div>
			</div>
		);

		let resultsInfo = (
			/* eslint-disable react/jsx-one-expression-per-line */
			<div className="C2-search-results__count">
				{resultsTotal} {resultsString}
			</div>
			/* eslint-enable react/jsx-one-expression-per-line */
		);

		if (viewport === 'md') {
			resultsInfo = (
				/* eslint-disable react/jsx-one-expression-per-line */
				<React.Fragment>
					<div className="C2-search-results__pagination">
						{ pageTotal > 0 ? this.renderPagination() : ''}
					</div>
					<div className="C2-search-results__count">
						{resultsTotal} {resultsString}
					</div>
				</React.Fragment>
				/* eslint-enable react/jsx-one-expression-per-line */
			);
		}

		if (['lg', 'xl', 'xxl'].includes(viewport)) {
			resultsInfo = (
				/* eslint-disable react/jsx-one-expression-per-line */
				<div className="C2-search-results__info">
					<div className="C2-search-results__count">
						{resultsTotal} {resultsString}
					</div>
					<div className="C2-search-results__pagination">
						{ pageTotal > 0 ? this.renderPagination() : ''}
					</div>
				</div>
				/* eslint-enable react/jsx-one-expression-per-line */
			);
		}

		let isFetching = null;
		if (waiting) {
			isFetching = (
				<div className="C2-search-results__loading-overlay">
					<div className="C2-search-results__loading loading">
						<div className="loading__dots">Loading...</div>
					</div>
				</div>
			)
		}

		return (
			<div className="container">
				<div className="row">
					<div className="C2-search-results__filter">
						<section className="C3-filter">
							{_.isEmpty(filterData) ? null : <C3Filter data={filterData} {...filterProps} /> }
						</section>
					</div>
					{['xs', 'sm', 'md'].includes(viewport) ? resultsInfo : null}
					<div className="C2-search-results__wrapper">
						{['lg', 'xl', 'xxl'].includes(viewport) ? resultsInfo : null}
						<div className="C2-search-results__inner">
							{['md', 'lg', 'xl', 'xxl'].includes(viewport) ? resultsHeader : null}
							{ results.map(this.renderResult) }
						</div>
						{ isFetching }
					</div>
					<div className="C2-search-results__pagination">
						{ pageTotal > 0 ? this.renderPagination() : ''}
					</div>
				</div>
			</div>
		);
	}
}

C2SearchResults.defaultProps = {
	viewport: 'xl',
	userLoggedIn: false,
	selectedTopics: {},
	selectedCategories: {},
	filterLanguage: {},
	sampleCartProducts: [],
	data: {
		endpoint: '',
		endpointDownloadAll: '',
		endpointParams: {
			lang: '',
			query: '',
		},
		content: {
			ofString: '',
			addSample: '',
			removeSample: '',
			please: '',
			logIn: '',
			logInDesktopString: '',
			headerProductNameAndHero: '',
			headerDocuments: '',
			headerRequestASample: '',
			resultsString: '',
			download: '',
		},
		filterProps: {
			content: {
				textOpen: '',
				textClose: '',
				textClear: '',
			},
		},
	},
	dispatch: () => {},
};

C2SearchResults.propTypes = {
	viewport: PropTypes.string,
	userLoggedIn: PropTypes.bool,
	selectedTopics: PropTypes.shape({}),
	selectedCategories: PropTypes.shape({}),
	filterLanguage: PropTypes.shape({}),
	sampleCartProducts: PropTypes.arrayOf(PropTypes.string),
	data: PropTypes.shape({
		endpoint: PropTypes.string,
		endpointDownloadAll: PropTypes.string,
		endpointParams: PropTypes.shape({
			lang: PropTypes.string,
			query: PropTypes.string,
		}),
		content: PropTypes.shape({
			ofString: PropTypes.string,
			addSample: PropTypes.string,
			removeSample: PropTypes.string,
			please: PropTypes.string,
			logIn: PropTypes.string,
			logInDesktopString: PropTypes.string,
			headerProductNameAndHero: PropTypes.string,
			headerDocuments: PropTypes.string,
			headerRequestASample: PropTypes.string,
			resultsString: PropTypes.string,
			download: PropTypes.string,
		}),
		filterProps: PropTypes.shape({
			content: PropTypes.shape({
				textOpen: PropTypes.string,
				textClose: PropTypes.string,
				textClear: PropTypes.string,
			}),
		}),
	}),
	dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
	return {
		viewport: state.global.viewport || null,
		userLoggedIn: state.global.userLoggedIn || false,
		selectedTopics: state.filter.selectedTopics || {},
		selectedCategories: state.filter.selectedCategories || {},
		filterLanguage: state.filter.currentLanguage || {},
		sampleCartProducts: state.sampleCart.products || [],
	};
};

export default connect(mapStateToProps)(C2SearchResults);
